import styled from "styled-components";
export const AuthWrapper = styled.div`
  background-color: #f8f8f8;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .ant-input-affix-wrapper {
    border: 1px solid #d9d9d9;
    border-radius: 6px;
  }
  .ant-input {
    font-size: 14px;
    font-weight: 400;
    line-height: 32px;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    padding: 0 16px;
    box-sizing: border-box;
  }
`;

export const SignInWrapper = styled.div`
  background-color: #fff;
  padding: 40px 60px 60px;
  box-shadow: rgb(64 87 109 / 7%) 0px 1px 4px;
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 100px;
  max-width: 440px;
  padding: 48px 32px;
  width: calc(100% - 16px);
  .ant-divider {
    align-items: flex-start;
  }
  .sign-in {
    &-title {
      font-size: 24px;
      margin-bottom: 30px;
      text-align: center;
    }
    &-logo {
      text-align: center;
      margin-bottom: 100px;
      img {
        height: 100px;
      }
    }
    &-forget-password {
      text-align: right;
      margin-bottom: 30px;
      margin-top: -15px;
    }
    &-up {
      margin-top: 40px;
      text-align: center;
    }
    &-btn {
      background-color: #981202;
      width: 100%;
      color: #fff;
      font-size: 16px;
      height: 50px;
      padding: 0 24px;
      line-height: 50px;
      letter-spacing: 0.5px;
      border-radius: 4px;
    }
  }
`;
